import React, { createContext, useContext } from 'react';
import Swal from 'sweetalert2';

const AlertContext = createContext(null);

export function useAlert() {
	return useContext(AlertContext);
}

export const Alert = ({ children }) => {
	function pushMessage(params) {
		// setMessage(params);

		const title = params.message?.length !== 0 ? params.message : 'Error';

		const Toast = Swal.mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 4000,
			timerProgressBar: true,
			didOpen: (toast) => {
				toast.addEventListener('mouseenter', Swal.stopTimer);
				toast.addEventListener('mouseleave', Swal.resumeTimer);
			},
		});

		Toast.fire({
			icon: params?.success ? 'success' : 'error',
			title: params?.success ? 'Success' : title,
		});
	}

	const state = {
		push: pushMessage,
	};

	return (
		<AlertContext.Provider value={state}>
			<div>{children}</div>
		</AlertContext.Provider>
	);
};
